import React from "react";
import InnerBanner from "../../components/InnerBanner";
import KeyExpertise from "../../components/KeyExpertise";

const Expertise = () => {
  return (
    <>
      <InnerBanner title="Expertise"/>
      <KeyExpertise container="default"/>
    </>
  );
};

export default Expertise;
